// Login.js
import React, { useState } from 'react';
import axios from 'axios';  
import { useAuth } from './auth.js'; // adjust path as needed
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from './baseurl.js';


const Login = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [message, setMessage] = useState('');
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 




  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/token/`, form);
        login(form.username, res.data.access);
        localStorage.setItem('access_token', res.data.access);   // updates global state and triggers re-render
        localStorage.setItem('refresh_token', res.data.refresh);
        setMessage('Login successful!');
      localStorage.setItem('username', res.data.username || form.username);
      setTimeout(() => setMessage(''), 3000);
      navigate('/home');
    } catch (err) {
      setMessage('Login failed. Check your credentials.');
      setTimeout(() => setMessage(''), 3000);
    }
    finally {
        setLoading(false); // ✅ Always stop loading
      }
  };

  return (
    <div className="container mt-5">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Username:</label>
          <input type="text" name="username" className="form-control" onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Password:</label>
          <input type="password" name="password" className="form-control" onChange={handleChange} required />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Processing...
            </>
          ) : (
            'Login'
          )}
        </button>
      </form>
      {message && <div className="alert mt-3 alert-info">{message}</div>}
    </div>
  );
};

export default Login;
